import React from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import DataLoadErrorAlert from "components/common/DataLoadErrorAlert";
import SectionCard from "components/dashboard/chartmind/SectionCard";
import { groupPearlsByDiagnosis } from "components/dashboard/chartmind/pearls";

/**
 * Teaching pearls for the Pearls step. When the model tags pearls with a diagnosis (Events
 * working differential), they render under that diagnosis heading. Otherwise each pearl is shown
 * on its own, as before.
 */
const PearlsStep = ({ pearls = [], loading = false, error = "", retry }) => {
  const groups = groupPearlsByDiagnosis(pearls);
  const hasDiagnosisGroups = groups.some((group) => group.diagnosis);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ mb: { xs: 1.5, sm: 2 } }}>
          Teaching Pearls
        </Typography>
      </Box>

      {error ? <DataLoadErrorAlert message={error} onRetry={retry} sx={{ width: "100%" }} /> : null}

      {loading && !pearls.length ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : null}

      {!loading && !error && !pearls.length ? (
        <Typography variant="body2" color="text.secondary" align="center">
          No pearls for this encounter.
        </Typography>
      ) : null}

      {hasDiagnosisGroups
        ? groups.map((group) =>
            group.pearls.length ? (
              <Box key={group.diagnosis || "ungrouped"} sx={{ mb: 3 }}>
                {group.diagnosis ? (
                  <Typography variant="h6" sx={{ mb: 1.5 }}>
                    {group.diagnosis}
                  </Typography>
                ) : null}
                {group.pearls.map((pearl) =>
                  pearl.title ? (
                    <SectionCard
                      key={pearl.id}
                      title={pearl.title}
                      content={pearl.body}
                      maxPreviewLength={2000}
                    />
                  ) : (
                    <Paper key={pearl.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
                      <Typography variant="body1">{pearl.body}</Typography>
                    </Paper>
                  ),
                )}
              </Box>
            ) : null,
          )
        : pearls.map((pearl) =>
            pearl.title ? (
              <SectionCard
                key={pearl.id}
                title={pearl.title}
                content={pearl.body}
                maxPreviewLength={2000}
              />
            ) : (
              <Paper key={pearl.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
                <Typography variant="body1">{pearl.body}</Typography>
              </Paper>
            ),
          )}
    </Box>
  );
};

export default PearlsStep;
